export const CHECKOUT_URL = 'https://praxis-en.impultienda.ar/checkout/';

export const images = {
  mockup: 'https://cdn.magicpatterns.com/uploads/9Le2WgFjrySd75V2a74aYR/MOCKUP_PRAXIS-EN.png',
  author: 'https://cdn.magicpatterns.com/uploads/mtSx7ZRnszgmmunVVjATpq/DR._ELOWEN_VARELLI_-_SENSORY.png',
};
